export function parceJson(json) {
    return JSON.parse(json || '{}');
}

export function getLocalStorage(key) {
    try {
        return window.localStorage[key] || '';
    } catch (e) {
        return '';
    }
}

export function setLocalStorage(key, value) {
    try {
        window.localStorage[key] = value;
        return window.localStorage[key];
    } catch (e) {
        return value;
    }
}

export function removeLocalStorage(key) {
    try {
        window.localStorage.removeItem(key);
    } catch (e) {
        // bloqueado em iframe cross-origin — ignorar silenciosamente
    }
}

export function clearLocalStorage() {
    try {
        window.localStorage.clear();
    } catch (e) {
        // bloqueado em iframe cross-origin — ignorar silenciosamente
    }
}

export function setObjLocalStorage(key, obj) {
    const value = JSON.stringify(obj);

    return setLocalStorage(key, value);
}

export function getObjLocalStorage(key) {
    const value = getLocalStorage(key);

    if (!value) return null;

    return parceJson(value);
}
